import axios from "axios";
import { AuthData } from "../types/types";
import { attachSentryResponseInterceptor } from "./sentryAxiosInterceptor";
import {
  AccessURL,
  CryptoTemsAndConditionsStatus,
} from "../components/CryptoSection/types";

//Axios instance
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_HORUS_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const localAuth = localStorage.getItem("allaria-auth");

    const parsedLocalAuth: AuthData | null =
      (localAuth && JSON.parse(localAuth)) ?? null;

    const token = parsedLocalAuth?.access_token;

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
attachSentryResponseInterceptor(axiosInstance);

export const generateAccess = async (accountId: Number): Promise<AccessURL> => {
  const res = await axiosInstance.post("/crypto/access-simple", { accountId });
  return res.data;
};

export const getTermsAndConditionsStatus = async (): Promise<
  CryptoTemsAndConditionsStatus[]
> => {
  const res = await axiosInstance.get("/crypto/terms");
  return res.data?.accounts;
};

export const acceptTermsAndConditions = async (
  accountIds: Number[],
): Promise<CryptoTemsAndConditionsStatus[]> => {
  const res = await axiosInstance.post("/crypto/terms", {
    accountIds,
    termsType: "CRYPTO",
  });
  return res.data?.accounts;
};
